import React from "react";

import { useState } from "react";
import Chevron from "../../components/common/Icons/Chevron";
import LinkNoStyle from "../../components/common/LinkNoStyle/LinkNoStyle";
import { usePageManager } from "../../context";
import * as styles from "./Pagination.module.scss";

export const Pagination: React.FC = () => {
	const { pagination, showPagination: globalShowPagination } = usePageManager();
	const [showPagination, setShowPagination] = useState(globalShowPagination);

	const togglePagination = (show: boolean) => {
		setShowPagination(show);
	};
	if (!pagination || !globalShowPagination) return null;

	return (
		<div className={styles.paginationwrapper}>
			<div
				className={
					showPagination
						? styles.paginationcontainer
						: styles.paginationcontainerhidden
				}
			>
				<button
					type="button"
					className={styles.paginationtoggletab}
					onClick={() => togglePagination(!showPagination)}
				>
					{`${showPagination ? "Hide" : "Show"}`}
					<Chevron height={"16px"} rotation={showPagination ? 180 : 0} />
				</button>
				<nav className={styles.pagination}>
					{pagination.pages?.[pagination.currentPage - 1]?.length > 0 ? (
						<LinkNoStyle
							className={styles.previous}
							to={pagination.pages[pagination.currentPage - 1]}
							state={{ pagination }}
						>
							Previous
						</LinkNoStyle>
					) : (
						<span aria-disabled className={styles.disabled}>
							Previous
						</span>
					)}
					<span className={styles.paginationtext}>{`${
						pagination.currentPage + 1
					} of ${pagination.totalPages}`}</span>

					{pagination.pages?.[pagination.currentPage + 1]?.length > 0 ? (
						<LinkNoStyle
							className={styles.next}
							to={pagination.pages[pagination.currentPage + 1]}
							state={{ pagination }}
						>
							Next
						</LinkNoStyle>
					) : (
						<span aria-disabled className={styles.disabled}>
							Next
						</span>
					)}
				</nav>
				<a href={pagination.listingPageUrl} className={styles.paginationlink}>
					Return to results
				</a>
			</div>
		</div>
	);
};
